const CitesMetadaten = () => {
    return {

    }
}
export default CitesMetadaten;